import React from "react";
import { Link } from "gatsby";
import { Breadcrumbs as MuiBreadcrumbs, Typography, Box } from "@mui/material";
import { ChevronRight, Home } from "lucide-react";
import {
  getLanguageAwarePath,
  getCurrentLanguage,
} from "../../utils/languageUtils";
import { useTranslation } from "react-i18next";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  const currentLanguage = getCurrentLanguage();
  const { t } = useTranslation("common");

  return (
    <Box sx={{ py: 2 }}>
      <MuiBreadcrumbs
        separator={<ChevronRight size={16} />}
        aria-label={String(t("aria.breadcrumb"))}
      >
        <Link
          to={getLanguageAwarePath("/", currentLanguage)}
          style={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            color: "primary.light",
          }}
        >
          <Home size={16} style={{ marginRight: 4, color: "primary.light" }} />
          {String(t("navigation.home"))}
        </Link>

        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          if (isLast || !item.path) {
            return (
              <Typography
                key={index}
                color={isLast ? "primary.dark" : "primary.light"}
                sx={{ fontWeight: isLast ? 600 : 400 }}
              >
                {item.label}
              </Typography>
            );
          }

          return (
            <Link
              key={index}
              to={getLanguageAwarePath(item.path, currentLanguage)}
              style={{
                textDecoration: "none",
                color: "primary",
              }}
            >
              <Typography color="primary">{item.label}</Typography>
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};
